"use client";

type Props = {
  count: number;
};

/**
 * Animated countdown display for video recording preparation.
 */
export const Countdown = ({ count }: Props) => (
  <div
    className="absolute inset-0 flex items-center justify-center bg-black/50"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <div className="animate-in fade-in zoom-in duration-300">
      <span className="text-9xl font-bold text-white drop-shadow-lg">
        {count}
      </span>
    </div>
  </div>
);
